var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"variant":_vm.config.type,"fade":"","dismissible":""},on:{"dismissed":_vm.dismissed},model:{value:(_vm.duration),callback:function ($$v) {_vm.duration=$$v},expression:"duration"}},[_c('h4',[_vm._v(_vm._s(_vm.config.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }